/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "omg": {
        "nested": {
          "cash": {
            "nested": {
              "CashLocalOrderExtension": {
                "fields": {
                  "brandToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "source": {
                    "type": ".squareup.omg.cash.CashLocalOrderExtension.CashLocalSource",
                    "id": 2,
                    "rule": "optional"
                  },
                  "brandOrderingUrl": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "locationToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "cartToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "cashCustomerToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "checkInToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "orderingGroups": {
                    "type": ".squareup.omg.cash.OrderingGroup",
                    "id": 8,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "CashLocalSource": {
                    "values": {
                      "DEFAULT_DO_NOT_USE": 0,
                      "SOURCE_WEB": 1,
                      "SOURCE_NATIVE": 2
                    }
                  }
                }
              },
              "OrderingGroup": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "createdAtMillis": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "source": {
                    "type": ".squareup.omg.cash.OrderingGroup.Source",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Source": {
                    "values": {
                      "UNKNOWN": 0,
                      "OPEN_TAB_ROUND": 1
                    }
                  }
                }
              },
              "CashLocalLineItemExtension": {
                "fields": {
                  "orderingGroupIds": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "CashLocalLineItemGroupExtension": {
                "fields": {
                  "orderingGroupIds": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.omg?.nested?.cash?.nested?.CashLocalOrderExtension && !$root.nested?.squareup?.nested?.omg?.nested?.cash?.nested?.CashLocalOrderExtension?.nested?.CashLocalSource && !$root.nested?.squareup?.nested?.omg?.nested?.cash?.nested?.OrderingGroup && !$root.nested?.squareup?.nested?.omg?.nested?.cash?.nested?.OrderingGroup?.nested?.Source && !$root.nested?.squareup?.nested?.omg?.nested?.cash?.nested?.CashLocalLineItemExtension && !$root.nested?.squareup?.nested?.omg?.nested?.cash?.nested?.CashLocalLineItemGroupExtension) {
  $root.addJSON(jsonData);
}

/**
 * Information about the cash-app-local order that was used to place this order
 *
 * SOURCE CashLocalOrderExtension @ squareup/omg/cash/extensions.proto at 14:1
 */
export const CashLocalOrderExtension = $root.lookupType('squareup.omg.cash.CashLocalOrderExtension');
fixType(CashLocalOrderExtension);
Builder.createAndAttachToType(CashLocalOrderExtension);
/**
 * SOURCE CashLocalSource @ squareup/omg/cash/extensions.proto at 15:3
 */
CashLocalOrderExtension.CashLocalSource = $root.lookupEnum('squareup.omg.cash.CashLocalOrderExtension.CashLocalSource').values;
/**
 * Identifies a set of line items added together in a single ordering action (e.g. one Open Tab
 * round). Stored as a normalized list on CashLocalOrderExtension.ordering_groups; items carry
 * only the ID reference.
 *
 * SOURCE OrderingGroup @ squareup/omg/cash/extensions.proto at 50:1
 */
export const OrderingGroup = $root.lookupType('squareup.omg.cash.OrderingGroup');
fixType(OrderingGroup, {
  id: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(OrderingGroup);
/**
 * SOURCE Source @ squareup/omg/cash/extensions.proto at 60:3
 */
OrderingGroup.Source = $root.lookupEnum('squareup.omg.cash.OrderingGroup.Source').values;
/**
 * Attached to each LineItem via OrderLineItemExtensions.cash_local_line_item_extension.
 *
 * SOURCE CashLocalLineItemExtension @ squareup/omg/cash/extensions.proto at 67:1
 */
export const CashLocalLineItemExtension = $root.lookupType('squareup.omg.cash.CashLocalLineItemExtension');
fixType(CashLocalLineItemExtension);
Builder.createAndAttachToType(CashLocalLineItemExtension);
/**
 * Attached to each LineItemGroup via OrderLineItemGroupExtensions.cash_local_line_item_group_extension.
 *
 * SOURCE CashLocalLineItemGroupExtension @ squareup/omg/cash/extensions.proto at 75:1
 */
export const CashLocalLineItemGroupExtension = $root.lookupType('squareup.omg.cash.CashLocalLineItemGroupExtension');
fixType(CashLocalLineItemGroupExtension);
Builder.createAndAttachToType(CashLocalLineItemGroupExtension);